(function () {
  var config = window.MKThemeConfig || {};
  var PRODUCT_ORDER = {
    'torre-fija': 0,
    'torre-plegable': 1,
    'torre-3en1': 2,
    'pikler-xl': 3,
    'climbing-3in1': 4,
    'triangulo-evolutivo': 5,
    'parque': 6,
    'pikler-escada': 7,
    'triangulo-triple': 8,
    'triangulo-triple-de-escalada-con-rampla-xl': 8,
    'cubo-aprendizaje': 9,
    'parque-plegable': 10,
    'gimnasio': 11,
    'mesa-2-sillas': 12,
    'pasarela': 13,
    'bici-rosada': 14,
    'bici-blanca': 15,
    'poly-pop': 16,
    'tablero-dinosaurio': 17,
    'tablero-oso': 18,
    'waldorf-xl-cojin': 19,
    'cojin-waldorf': 20,
    'set-equilibrio': 21,
    'arcoiris-waldorf': 22,
    'arcoiris-waldorf-montessori-12pcs': 22,
    'triangulo-evolutivo-con-rampla': 5,
    'tabla-colores': 23,
    'tabla-gris': 24,
    'tabla-amarilla': 25,
    'tabla-rosada': 26
  };

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function compactProductTitle(title) {
    var cleaned = String(title || '').trim();

    if (cleaned.indexOf(' | ') > -1) {
      cleaned = cleaned.split(' | ')[0].trim();
    }

    if (cleaned.indexOf(' – ') > -1) {
      cleaned = cleaned.split(' – ')[0].trim();
    } else if (cleaned.indexOf(' - ') > -1) {
      cleaned = cleaned.split(' - ')[0].trim();
    }

    return cleaned;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || '.';
    decimal = decimal || ',';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  function formatMoney(cents, format) {
    format = format || config.moneyFormat || '${{amount_no_decimals}}';

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var value = '';
    var match = format.match(placeholderRegex);

    if (!match) {
      return cents;
    }

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_no_decimals_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 0);
        break;
    }

    return format.replace(placeholderRegex, value);
  }

  function ensureToast() {
    var toast = q('.toast');
    if (toast) {
      return toast;
    }

    toast = document.createElement('div');
    toast.className = 'toast';
    toast.innerHTML = '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg><span class="toast-msg"></span>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(message) {
    var toast = ensureToast();
    var label = q('.toast-msg', toast);
    var timer = toast._timer;

    if (label) {
      label.textContent = message;
    }

    toast.classList.add('show');
    if (timer) {
      window.clearTimeout(timer);
    }

    toast._timer = window.setTimeout(function () {
      toast.classList.remove('show');
    }, 2200);
  }

  function toggleFavoriteButton(button) {
    if (!button) {
      return;
    }

    var isOn = button.classList.toggle('on');
    button.setAttribute('aria-pressed', isOn ? 'true' : 'false');
  }

  var cartState = {
    initialized: false,
    overlay: null,
    drawer: null,
    items: null,
    foot: null
  };

  function syncBodyScrollLock() {
    var shouldLock = !!(cartState.drawer && cartState.drawer.classList.contains('open'));
    document.body.classList.toggle('is-locked', shouldLock);
  }

  function openCart() {
    if (!cartState.drawer || !cartState.overlay) {
      return;
    }

    cartState.overlay.classList.add('open');
    cartState.drawer.classList.add('open');
    syncBodyScrollLock();
  }

  function closeCart() {
    if (!cartState.drawer || !cartState.overlay) {
      return;
    }

    cartState.overlay.classList.remove('open');
    cartState.drawer.classList.remove('open');
    syncBodyScrollLock();
  }

  function updateCartCount(count) {
    qa('.cart-count').forEach(function (node) {
      node.textContent = count;
      node.classList.toggle('show', count > 0);
    });
  }

  function emptyCartHtml() {
    return (
      '<div class="cart-empty">' +
      '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>' +
      '<p>Tu carrito est&aacute; vac&iacute;o.<br>Suma una pieza para empezar a jugar.</p></div>'
    );
  }

  function lineItemHtml(item) {
    var image = '';
    var title = compactProductTitle(item.product_title);
    if (item.featured_image && item.featured_image.url) {
      image = '<img src="' + escapeHtml(item.featured_image.url) + '" alt="' + escapeHtml(item.featured_image.alt || item.product_title) + '">';
    }

    return (
      '<div class="ci">' +
      image +
      '<div>' +
      '<div class="ci-t"><a href="' + escapeHtml(item.url || ((config.routes && config.routes.cart) || '/cart')) + '">' + escapeHtml(title) + '</a></div>' +
      '<div class="ci-p">' + formatMoney(item.final_price) + '</div>' +
      '<div class="qty">' +
      '<button type="button" aria-label="Quitar uno" data-cart-dec="' + escapeHtml(item.key) + '">&minus;</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" aria-label="Agregar uno" data-cart-inc="' + escapeHtml(item.key) + '">+</button>' +
      '</div></div>' +
      '<div style="text-align:right">' +
      '<div class="ci-t">' + formatMoney(item.final_line_price) + '</div>' +
      '<button class="ci-x" type="button" data-cart-rm="' + escapeHtml(item.key) + '">Eliminar</button></div></div>'
    );
  }

  function renderCart(cart) {
    if (!cartState.items || !cartState.foot) {
      return;
    }

    updateCartCount(cart.item_count || 0);

    if (!cart.items || !cart.items.length) {
      cartState.items.innerHTML = emptyCartHtml();
      cartState.foot.style.display = 'none';
      return;
    }

    cartState.items.innerHTML = cart.items.map(lineItemHtml).join('');
    cartState.foot.style.display = 'block';

    qa('[data-total]', cartState.drawer).forEach(function (node) {
      node.textContent = formatMoney(cart.items_subtotal_price);
    });

    var cuotaNode = q('[data-cuota]', cartState.drawer);
    if (cuotaNode) {
      cuotaNode.textContent = formatMoney(Math.round(cart.items_subtotal_price / 3));
    }
  }

  function refreshCart(openAfter) {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      if (openAfter) {
        openCart();
      }
      return cart;
    });
  }

  function addToCart(variantId, quantity) {
    return fetch((config.routes && config.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: quantity || 1
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (payload) {
          throw new Error(payload.description || 'No fue posible agregar este producto.');
        });
      }
      return response.json();
    }).then(function (payload) {
      var title = payload.items && payload.items[0] ? payload.items[0].title : 'Producto';
      showToast(title + ' - ' + (config.labels && config.labels.added ? config.labels.added : 'agregado'));
      return refreshCart(true);
    }).catch(function (error) {
      showToast(error.message || 'No fue posible agregar este producto.');
    });
  }

  function changeCartLine(key, quantity) {
    return fetch((config.routes && config.routes.cartChange) || '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      latestCart = cart;
      renderCart(cart);
    });
  }

  function initCart() {
    cartState.overlay = q('.cart-overlay');
    cartState.drawer = q('.cart-drawer');
    cartState.items = q('.cart-items');
    cartState.foot = q('.cart-foot');

    if (!cartState.drawer || !cartState.overlay || cartState.initialized) {
      return;
    }

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-open-cart]');
      if (openButton) {
        event.preventDefault();
        refreshCart(true);
        return;
      }

      var closeButton = event.target.closest('[data-close-cart]');
      if (closeButton) {
        event.preventDefault();
        closeCart();
        return;
      }

      var favoriteButton = event.target.closest('[data-favorite-toggle]');
      if (favoriteButton) {
        event.preventDefault();
        toggleFavoriteButton(favoriteButton);
        return;
      }

      var addButton = event.target.closest('[data-add]');
      if (addButton) {
        event.preventDefault();
        addToCart(addButton.getAttribute('data-add'), Number(addButton.getAttribute('data-qty') || 1));
        return;
      }

      var inc = event.target.closest('[data-cart-inc]');
      if (inc) {
        event.preventDefault();
        var incKey = inc.getAttribute('data-cart-inc');
        var line = findCartItemByKey(incKey);
        if (line) {
          changeCartLine(incKey, line.quantity + 1);
        }
        return;
      }

      var dec = event.target.closest('[data-cart-dec]');
      if (dec) {
        event.preventDefault();
        var decKey = dec.getAttribute('data-cart-dec');
        var decLine = findCartItemByKey(decKey);
        if (decLine) {
          changeCartLine(decKey, decLine.quantity - 1);
        }
        return;
      }

      var rm = event.target.closest('[data-cart-rm]');
      if (rm) {
        event.preventDefault();
        changeCartLine(rm.getAttribute('data-cart-rm'), 0);
        return;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeCart();
      }
    });

    cartState.overlay.addEventListener('click', closeCart);
    cartState.initialized = true;
    refreshCart(false);
  }

  var latestCart = null;

  function findCartItemByKey(key) {
    if (!latestCart || !latestCart.items) {
      return null;
    }
    return latestCart.items.find(function (item) {
      return item.key === key;
    }) || null;
  }

  function fetchCart() {
    return fetch((config.routes && config.routes.cart) || '/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      latestCart = cart;
      return cart;
    });
  }

  function bindProductForms(root) {
    qa('form.product-form', root).forEach(function (form) {
      if (form.dataset.mkBound === 'true') {
        return;
      }

      form.dataset.mkBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var formData = new FormData(form);
        addToCart(formData.get('id'), Number(formData.get('quantity') || 1));
      });
    });
  }

  function initProductGallery(root) {
    qa('.pdp-gallery', root).forEach(function (gallery) {
      if (gallery.dataset.mkBound === 'true') {
        return;
      }

      gallery.dataset.mkBound = 'true';
      var mainImage = q('.pdp-main-image', gallery);
      if (!mainImage) {
        return;
      }

      qa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          qa('[data-gallery-thumb]', gallery).forEach(function (button) {
            button.classList.remove('on');
          });
          thumb.classList.add('on');
          mainImage.src = thumb.getAttribute('data-gallery-thumb');
          mainImage.alt = thumb.getAttribute('data-gallery-alt') || mainImage.alt;
          mainImage.removeAttribute('srcset');
        });
      });
    });
  }

  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      qa('.reveal', root).forEach(function (node) {
        node.classList.add('in');
      });
      return;
    }

    if (!window._mkObserver) {
      window._mkObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            window._mkObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
    }

    qa('.reveal', root).forEach(function (node) {
      if (!node.classList.contains('in')) {
        window._mkObserver.observe(node);
      }
    });
  }

  function getCardHandle(card) {
    if (card.dataset.handle) {
      return card.dataset.handle;
    }

    var link = q('.ttl a, .media a', card);
    if (!link) {
      return '';
    }

    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : href;
  }

  function getCardMeta(card) {
    var handle = getCardHandle(card);
    var rank = Object.prototype.hasOwnProperty.call(PRODUCT_ORDER, handle) ? PRODUCT_ORDER[handle] : 9999;
    var available = card.dataset.available !== 'false' && !card.classList.contains('is-out');
    var stock = Number(card.dataset.stock || (available ? 9999 : 0));
    var featured = card.dataset.featured === 'true';
    var star = card.dataset.star === 'true';

    return {
      card: card,
      handle: handle,
      rank: rank,
      line: card.dataset.linea || '',
      offer: card.dataset.estado === 'oferta',
      available: available,
      stock: isNaN(stock) ? 0 : stock,
      featured: featured,
      star: star,
      featuredLike: featured || star,
      productId: card.dataset.productId || ''
    };
  }

  function compareCatalogCards(a, b) {
    if (a.available !== b.available) {
      return a.available ? -1 : 1;
    }
    if (a.featuredLike !== b.featuredLike) {
      return a.featuredLike ? -1 : 1;
    }
    return a.rank - b.rank;
  }

  function compareOfferCards(a, b) {
    if (a.featuredLike !== b.featuredLike) {
      return a.featuredLike ? -1 : 1;
    }
    if (a.stock !== b.stock) {
      return b.stock - a.stock;
    }
    return a.rank - b.rank;
  }

  function sortByRank(a, b) {
    return a.rank - b.rank;
  }

  function interleaveByLine(items, limit) {
    var movement = items.filter(function (item) {
      return item.line === 'movimiento';
    }).sort(sortByRank);
    var sensory = items.filter(function (item) {
      return item.line === 'sensorial';
    }).sort(sortByRank);
    var other = items.filter(function (item) {
      return item.line !== 'movimiento' && item.line !== 'sensorial';
    }).sort(sortByRank);
    var selected = [];
    var i = 0;

    while (selected.length < limit && (i < movement.length || i < sensory.length)) {
      if (i < movement.length) {
        selected.push(movement[i]);
      }
      if (selected.length >= limit) {
        break;
      }
      if (i < sensory.length) {
        selected.push(sensory[i]);
      }
      i += 1;
    }

    movement.slice(i).concat(sensory.slice(i)).concat(other).sort(sortByRank).forEach(function (item) {
      if (selected.length < limit) {
        selected.push(item);
      }
    });

    return selected;
  }

  function sortVisibleCards(grid, comparator) {
    if (!grid) {
      return;
    }

    var visible = qa('.card:not([hidden])', grid).map(getCardMeta).sort(comparator);
    var hidden = qa('.card[hidden]', grid);

    visible.forEach(function (item) {
      grid.appendChild(item.card);
    });

    hidden.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function renderHomeGrid(grid) {
    if (!grid || grid.dataset.mkBound === 'true') {
      return;
    }

    grid.dataset.mkBound = 'true';
    var role = grid.dataset.homeRole || 'recommended';
    var cards = qa('.card', grid).map(getCardMeta);
    var selected = [];
    var used = {};
    var emptyNote = document.createElement('div');
    emptyNote.className = 'empty-note';
    emptyNote.textContent = 'No hay productos con estos filtros. Prueba con otra combinaci\u00f3n.';
    emptyNote.hidden = true;
    grid.parentNode.insertBefore(emptyNote, grid.nextSibling);

    if (role === 'offers') {
      selected = cards.filter(function (item) {
        return item.offer && item.available && item.stock > 0;
      }).sort(compareOfferCards).slice(0, 4);
    } else {
      var availableCards = cards.filter(function (item) {
        return item.available && item.stock > 0;
      });
      var featuredCards = availableCards.filter(function (item) {
        return item.featuredLike;
      });
      if (featuredCards.length) {
        selected = interleaveByLine(featuredCards, 8);
        selected.forEach(function (item) {
          used[item.handle] = true;
        });
        if (selected.length < 8) {
          interleaveByLine(availableCards.filter(function (item) {
            return !used[item.handle];
          }), 8 - selected.length).forEach(function (item) {
            selected.push(item);
            used[item.handle] = true;
          });
        }
      } else {
        selected = interleaveByLine(availableCards, 8);
      }
    }

    used = {};
    selected.forEach(function (item) {
      used[item.handle] = true;
    });

    cards.forEach(function (item) {
      item.card.hidden = !used[item.handle];
    });

    selected.forEach(function (item) {
      grid.appendChild(item.card);
    });

    qa('.card[hidden]', grid).forEach(function (card) {
      grid.appendChild(card);
    });

    emptyNote.hidden = selected.length !== 0;
  }

  function initHomeGrids(root) {
    qa('[data-home-grid]', root).forEach(renderHomeGrid);
  }

  function initCatalog(root) {
    qa('[data-mk-catalog]', root).forEach(function (catalog) {
      if (catalog.dataset.mkCatalogBound === 'true') {
        return;
      }

      catalog.dataset.mkCatalogBound = 'true';
      var state = {
        linea: 'todas',
        estado: 'todo'
      };
      var params = new URLSearchParams(window.location.search);
      if (params.get('linea') === 'movimiento' || params.get('linea') === 'sensorial') {
        state.linea = params.get('linea');
      }
      if (params.get('estado') === 'oferta') {
        state.estado = 'oferta';
      }

      var titleNode = q('[data-catalog-title]', catalog);
      var descNode = q('[data-catalog-desc]', catalog);
      var countNode = q('[data-catalog-count]', catalog);
      var groups = qa('[data-catalog-group]', catalog);
      var rootNode = q('[data-catalog-root]', catalog);
      var emptyNote = document.createElement('div');
      emptyNote.className = 'empty-note';
      emptyNote.hidden = true;
      emptyNote.textContent = 'No hay productos con estos filtros. Prueba con otra combinaci\u00f3n.';
      if (rootNode) {
        rootNode.appendChild(emptyNote);
      }

      function setChipState(selector, value) {
        qa(selector, catalog).forEach(function (chip) {
          var dataKey = selector.indexOf('linea') > -1 ? 'catalogLinea' : 'catalogEstado';
          chip.classList.toggle('on', chip.dataset[dataKey] === value);
        });
      }

      function setTexts() {
        if (!titleNode || !descNode) {
          return;
        }

        if (state.linea !== 'todas') {
          titleNode.textContent = state.linea === 'movimiento' ? catalog.dataset.movementTitle : catalog.dataset.sensoryTitle;
          descNode.textContent = state.linea === 'movimiento' ? catalog.dataset.movementDesc : catalog.dataset.sensoryDesc;
        } else if (state.estado === 'oferta') {
          titleNode.textContent = catalog.dataset.offerTitle;
          descNode.textContent = catalog.dataset.offerDesc;
        } else {
          titleNode.textContent = catalog.dataset.defaultTitle;
          descNode.textContent = catalog.dataset.defaultDesc;
        }
      }

      function updateUrl() {
        var next = new URLSearchParams();
        if (state.linea !== 'todas') {
          next.set('linea', state.linea);
        }
        if (state.estado === 'oferta') {
          next.set('estado', 'oferta');
        }
        var query = next.toString();
        var url = window.location.pathname + (query ? '?' + query : '');
        window.history.replaceState({}, '', url);
      }

      function render() {
        var visibleCount = 0;

        groups.forEach(function (group) {
          var line = group.dataset.catalogGroup;
          var grid = q('.grid-cards', group);
          var cards = qa('.card', group);

          cards.forEach(function (card) {
            var matchLine = state.linea === 'todas' || line === state.linea;
            var matchState = state.estado === 'todo' || card.dataset.estado === 'oferta';
            var visible = matchLine && matchState;
            card.hidden = !visible;
            if (visible) {
              visibleCount += 1;
            }
          });

          if (grid) {
            sortVisibleCards(grid, compareCatalogCards);
          }

          group.hidden = qa('.card:not([hidden])', group).length === 0;
        });

        if (countNode) {
          countNode.textContent = visibleCount;
        }

        emptyNote.hidden = visibleCount !== 0;
        setTexts();
        setChipState('[data-catalog-linea]', state.linea);
        setChipState('[data-catalog-estado]', state.estado);
        updateUrl();
      }

      qa('[data-catalog-linea]', catalog).forEach(function (chip) {
        chip.addEventListener('click', function () {
          state.linea = chip.dataset.catalogLinea;
          render();
        });
      });

      qa('[data-catalog-estado]', catalog).forEach(function (chip) {
        chip.addEventListener('click', function () {
          state.estado = chip.dataset.catalogEstado;
          render();
        });
      });

      render();
    });
  }

  function initRelated(root) {
    qa('[data-related-root]', root).forEach(function (grid) {
      if (grid.dataset.mkBound === 'true') {
        return;
      }

      grid.dataset.mkBound = 'true';
      var currentId = grid.dataset.currentProductId || '';
      var section = grid.closest('[data-related-section]') || grid.closest('.related');
      var cards = qa('.card', grid).map(getCardMeta).filter(function (item) {
        return String(item.productId) !== String(currentId);
      }).sort(compareCatalogCards).slice(0, 3);
      var used = {};

      cards.forEach(function (item) {
        used[item.productId] = true;
      });

      qa('.card', grid).forEach(function (card) {
        card.hidden = !used[card.dataset.productId];
      });

      cards.forEach(function (item) {
        grid.appendChild(item.card);
      });

      qa('.card[hidden]', grid).forEach(function (card) {
        grid.appendChild(card);
      });

      if (section) {
        section.hidden = cards.length === 0;
      }
    });
  }

  function init(root) {
    initCart();
    bindProductForms(root);
    initProductGallery(root);
    initReveal(root);
    initHomeGrids(root);
    initCatalog(root);
    initRelated(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
